import { useEffect, useState } from 'react'
import { Alert, AlertDescription } from '@/components/ui/alert'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import Skeleton from '@/components/ui/skeleton'
import { CompareTable } from './compare-table'
import { usePaybackCompare } from './use-payback'

/** 最新安装日 = 截止日 − 1（回传滞后 1 天，与服务端默认主角一致） */
const latestInstallDate = (asOf) => new Date(Date.parse(`${asOf}T00:00:00Z`) - 86400000).toISOString().slice(0, 10)

/**
 * MON-81 同期对比：以主角安装日队列为主角，对照昨天 / 上周同日 / 上月同日 / 去年同日与 5 条均线的检查点表。
 * MON-86 去掉曲线图（接口 curve 字段保留，前端只用于判断回本日 >180）。
 * query = { node, countries }（MON-93 与页面同一范围）；asOf 未就绪时不发请求
 */
export default function CompareSection({ query, asOf }) {
  const [date, setDate] = useState('')
  // 换截止日后回到默认主角
  useEffect(() => setDate(''), [asOf])
  const compare = usePaybackCompare(asOf ? { ...query, asOf, date } : null)
  const data = compare.data
  const subjectDate = date || data?.subject.installDate || ''

  return (
    <Card>
      <CardHeader className="flex flex-col gap-3 md:flex-row md:items-start md:justify-between">
        <CardTitle className="text-base">同期对比</CardTitle>
        <label className="flex flex-col gap-1 text-sm">
          <span className="text-xs text-muted-foreground">选择对比日期</span>
          <Input
            aria-label="选择对比日期"
            type="date"
            className="w-44"
            value={subjectDate}
            min="2025-05-01"
            max={asOf ? latestInstallDate(asOf) : undefined}
            onChange={(event) => setDate(event.target.value)}
          />
        </label>
      </CardHeader>
      <CardContent className="flex flex-col gap-4">
        {compare.error && (
          <Alert variant="destructive">
            <AlertDescription>同期对比读取失败：{compare.error}</AlertDescription>
          </Alert>
        )}
        {!compare.error && !data && (
          <Skeleton role="status" className="h-80 rounded-xl" />
        )}
        {data && <CompareTable data={data} />}
      </CardContent>
    </Card>
  )
}
